import { Link } from "react-router-dom";
import { DatabaseBackup, ArrowRight } from "lucide-react";

const DAY = 86400000;

export const BackupReminder = ({ last, loading }) => {
  if (loading) return null;
  const age = last ? Math.floor((Date.now() - new Date(last.created_at).getTime()) / DAY) : null;
  if (age !== null && age < 7) return null;
  return (
    <section className="mb-8 rounded-lg border border-[#EF4444]/50 bg-[#FDECEC] p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3"
      data-testid="backup-reminder-card">
      <div className="flex items-center gap-3">
        <DatabaseBackup className="w-6 h-6 text-[#EF4444] shrink-0" />
        <div>
          <h2 className="font-display text-xl font-bold uppercase tracking-tight">Yedek Alın</h2>
          <p className="text-sm text-[#6B5B4A]" data-testid="backup-reminder-text">
            {age === null ? "Henüz hiç yedek alınmadı." : `Son yedek ${age} gün önce alındı.`} Verilerinizi korumak için yedek indirin.
          </p>
        </div>
      </div>
      <Link to="/yedek" data-testid="backup-reminder-link"
        className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-[#EF4444] hover:bg-[#B91C1C] text-white font-display uppercase tracking-wide text-sm">
        Yedeklemeye git <ArrowRight className="w-4 h-4" />
      </Link>
    </section>
  );
};
